export const SoundEvents = {
    ON: 'on',
    OFF: 'off',
    STATE_CHANGED: 'STATE_CHANGED',
    CHANNEL_STATE_CHANGED: 'CHANNEL_STATE_CHANGED'
};
export default SoundEvents;
